import React from 'react';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';
import HeroSkinny from 'marketing-website/components/modules/Hero/HeroSkinny';

import Pricing from './Pricing.js';
import Features from './Features.js';
import CtaFooter from './CtaFooter.js';
import Faq from './Faq.js';
import Support from './Support.js';
import heapTrackEvent from '../../utils/heapTrackEvent';

export default function PricingPage() {
  heapTrackEvent('Viewed old paywall');

  return (
    <Page
      title="Pricing and plans | Marvel"
      meta={[
        {
          name: 'description',
          content: 'Pricing for individuals, teams and Enterprise',
        },
        {
          name: 'keywords',
          content: 'pricing, price, plans, enterprise, free',
        },
      ]}
      header
      footer
    >
      <HeroSkinny
        title="Supercharge your design productivity"
        tag="h1"
        copy="Marvel is perfect for individuals and teams of all sizes. Start for free."
      />
      <Spacing type="padding" size="xl" position="bottom">
        <Pricing />
      </Spacing>
      <Features />
      <CtaFooter />
      <Faq />
      <Support />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pricing/index.js